import convertList from '../convertList';
import confGroup from './confGroup';
import discuss from './discuss';
import filters from '../filters';

export default function(config) {
    const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    return new Promise((resolve, reject) => {
        const newList = [];
        confGroup({
            base: {
                field: 'confGroup'
            },
            extendConfig: {
                confGroup: selfConfig
            }
        })
            .then(list => {
                newList.push({
                    id: 0,
                    groupName: '群聊',
                    groupList: filters.filterTroopList(list, selfConfig),
                    type: 'group',
                    total: list.length,
                    loaded: true
                });

                return discuss({
                    base: {
                        field: 'discuss'
                    },
                    extendConfig: {
                        discuss: selfConfig
                    }
                });
            })
            .then(list => {
                newList.push({
                    id: 1,
                    groupName: '多人聊天',
                    groupList: filters.filterTroopList(list, selfConfig),
                    type: 'group',
                    total: list.length,
                    loaded: true
                });

                resolve(
                    convertList(
                        newList,
                        {
                            groupName: 'groupName',
                            list: 'groupList'
                        },
                        {
                            groupId: '0',
                            transformGroup(originItem) {
                                const item = originItem;
                                item.loaded = true;
                                return item;
                            }
                        }
                    )
                );
            })
            .catch(err => {
                reject(err);
            });
    });
}
